import { HttpContextToken } from '@angular/common/http';

export const ENTITY_NAME_TOKEN = new HttpContextToken<string>(() => '');
